<template>
  <CdrBreadcrumb
    :items="breadcrumbData.breadcrumbList"
    :truncation-enabled="false"
    class="wishlists-breadcrumb"
    data-ui="wishlists-breadcrumb"
  >
  </CdrBreadcrumb>
</template>

<script>
import { CdrBreadcrumb } from '@rei/cedar';

export default {
  name: 'BreadCrumbComponent',
  components: {
    CdrBreadcrumb,
  },
  props: {
    breadcrumbData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens';
.wishlists-breadcrumb {
  a {
    color: $cdr-color-text-primary;
    font-size: $cdr-text-heading-sans-200-size;
    text-decoration: none;
    &:hover {
      color: $cdr-color-text-link-hover;
      text-decoration: underline;
    }
  }
}
</style>
